<template>
  <div>
    <div class="w-100 mobile-header">
      <p>{{ tabIndex === 0 ? 'Terms of use' : 'Privacy Policy' }}</p>
      <div class="close-btn" @click="goToHome()">
        <i class="icon-close" />
      </div>
    </div>
    <div class="container general-conditions">
      <vue-content-loading v-if="false" :height="60" :speed="1">
        <rect x="0" y="0" rx="4" ry="4" width="100%" height="60" />
      </vue-content-loading>
      <div v-else>
        <b-nav class="nav sub-nav mb-4 mt-2">
          <b-nav-item
            id="tab-hrcheckup-1"
            class="nav-item black d-flex align-items-center"
            :active="tabIndex === 0"
            @click="changeTab(0)"
          >
            Terms of use
          </b-nav-item>

          <b-nav-item
            id="tab-hrcheckup-2"
            class="nav-item black d-flex align-items-center"
            :active="tabIndex === 1"
            @click="changeTab(1)"
          >
            Privacy Policy
          </b-nav-item>
        </b-nav>
        <div v-if="tabIndex === 0" class="general-conditions__content">
          <TermsOfUse />
        </div>
        <div v-if="tabIndex === 1" class="general-conditions__content">
          <PrivacyPolicy />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PrivacyPolicy from './hrVenue/GeneralConditions/PrivacyPolicy.vue';
import TermsOfUse from './hrVenue/GeneralConditions/TermsOfUse.vue';

export default {
  name: 'GeneralConditions',
  components: {
    PrivacyPolicy,
    TermsOfUse,
  },

  data() {
    return {
      tabIndex: 0,
    };
  },

  async created() {
    this.setCurrentInterviewType();
  },

  methods: {
    setCurrentInterviewType() {
      const viewName = this.$route.params.tabName;
      switch (viewName) {
        case undefined:
          this.tabIndex = 0;
          break;
        case 'terms-of-use':
          this.tabIndex = 0;
          break;
        case 'privacy-policy':
          this.tabIndex = 1;
          break;
        default:
          this.$router.push('/page-not-found');
          break;
      }
    },

    changeTab(index) {
      let tabName = '';

      switch (index) {
        case 0:
          tabName = 'terms-of-use';
          break;
        case 1:
          tabName = 'privacy-policy';
          break;
        default:
          this.$router.push('/page-not-found');
          break;
      }

      this.$router.push({
        params: {
          ...this.$route.params,
          tabName,
        },
      });
    },

    goToHome() {
      this.$router.push('/');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/style/starter.scss";

.page-view {
  top: 0 !important;
}

.general-conditions {
  .sub-nav {
    justify-content: center;
    position: relative;

    &::after {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      display: -ms-flexbox;
      display: flex;
      width: 100%;
      height: 2px;
      background: #e4e4e4;
    }

    .nav-item {
      z-index: 1;

      a {
        color: #333;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }

      a.active {
        color: #333 !important;

        &::after {
          border-radius: 0 !important;
        }
      }
    }
  }
}

.mobile-header {
  display: none;

  @include media-breakpoint-down(sm) {
    display:flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    padding-left: 27px;
    border-bottom: 1px solid #E4E4E4;
  }

  p {
    color: #333;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
}

.close-btn {
  display: none;

  @include media-breakpoint-down(sm) {
    display:flex;
    justify-content: flex-end;
    align-items: center;
  }

  i {
    display: none;
    font-size: 24px;

    @include media-breakpoint-down(sm) {
      display: block;
    }
  }
}
</style>
